import gql from 'graphql-tag';

const WISHLIST_PRODUCTS = gql`
    query($limit: Int, $offset: Int, $sessionId: [String]) {
        count: wishlistCount

        products: wishlists(
            limit: $limit
            offset: $offset
            sessionId: $sessionId
        ) {
            id

            items {
                element {
                    ... on tile_Product {
                        id
                        title
                        uri
                        defaultPrice

                        vendor {
                            id
                            title
                        }

                        productTag {
                            id
                            title
                        }

                        variants {
                            id
                            title
                            price
                            salePrice
                            isAvailable
                            isDefault

                            ... on tile_Variant {
                                pricePerM2
                                colour {
                                    id
                                    title

                                    ... on colours_Category {
                                        colourHex
                                    }
                                }
                                tileImage @transform(format: "webp") {
                                    title
                                    url(width: 1, height: 1, immediately: false)
                                    srcset(sizes: ["320", "640"])
                                }
                                additionalImages @transform(format: "webp") {
                                    title
                                    url(width: 1, height: 1, immediately: false)
                                    srcset(sizes: ["320", "640"])
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export { WISHLIST_PRODUCTS };
